const initialState = {
  dataFiltersInstalador: [],
  loadingFiltersInstalador: true,
  statusFiltersInstalador: 0,
  dataFiltersContainer: [],
  loadingFiltersContainer: true,
  statusFiltersContainer: 0,
  dataFiltersSitio: [],
  loadingFiltersSitio: true,
  statusFiltersSitio: 0,
  dataFiltersProduct: [],
  loadingFiltersProduct: true,
  statusFiltersProduct: 0,
  dataFiltersHours: [],
  loadingFiltersHours: true,
  statusFiltersHours: 0,
  id_client: "",
  id_product: "",
};

export default initialState;
